/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_When_TodayInputs */

const en_us2_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const pt_br2_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const es_419_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoy`)
};

const pt_pt2_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoje`)
};

const fr_fr2_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aujourd'hui`)
};

const de_de2_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute`)
};

const it_it2_workout_quick_when_today = /** @type {(inputs: Workout_Quick_When_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oggi`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Workout_Quick_When_TodayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_when_today = /** @type {((inputs?: Workout_Quick_When_TodayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_When_TodayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_when_today(inputs)
	if (locale === "es-419") return es_419_workout_quick_when_today(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_when_today(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_when_today(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_when_today(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_when_today(inputs)
	return en_us2_workout_quick_when_today(inputs)
});
export { workout_quick_when_today as "workout-quick.when_today" }